import { XBasicCard } from '@adornis/chemistry/elements/components/x-card.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-card
 */
@customElement('cr-basic-card')
export class ChromiumBasicCard extends XBasicCard {
  override styles() {
    return [
      ...super.styles(),
      {
        padding: this.spacing.md,
        borderRadius: '15px',
        backgroundColor: 'white',
      },
    ];
  }
}
